import type { UploadRecoveryItem } from "@/api";
import { TableRow } from "@carbon6/c6-frontend-design";

export class UploadRecoveryTableRow extends TableRow {
  constructor(readonly item: UploadRecoveryItem) {
    super(null);
  }
  get uuid() {
    return this.item.uuid;
  }
  get kind() {
    return this.item.kind;
  }
  get displayName() {
    return this.item.display_name;
  }
  get status() {
    return this.item.status;
  }
  get datasetUuid() {
    return this.item.dataset_uuid;
  }
  get modifiedAt() {
    return this.item.modified_at;
  }
  get importAttempts() {
    return this.item.import_attempts;
  }
  get cleanupStatus() {
    return this.item.cleanup_status;
  }

  getRowId(): string {
    return `${this.kind}:${this.uuid}`;
  }
  canShow(): boolean {
    return true;
  }
  canSelect(): boolean {
    return false;
  }
}
